import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { UseraccountModel } from '../../amm-share/models';
import { GoogleApiService } from '../../amm-share/services/google-api.service';
import { RouterModule } from '@angular/router';
import { RegisterStepComponent } from "../../amm-share/components/register-steps/register-steps.component";

@Component({
  selector: 'amm-page-register',
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    RegisterStepComponent
],
  templateUrl: './page-register.component.html',
  styleUrl: './page-register.component.scss',
  providers: [GoogleApiService],
})
export class PageRegisterComponent implements OnInit {

  @Input()
  step?: string;

  private dialogConfig = inject(DynamicDialogConfig<PageRegisterComponent>);
  constructor(
    public ref: DynamicDialogRef<PageRegisterComponent>,
    public dialog: DialogService
  ) { }

  userInfo?: UseraccountModel;

  stayLoggedin: boolean = false;
  currentVarifyStep: string = '';

  ngOnInit(): void {
    this.step = this.dialogConfig?.data?.step;
  }

  onCloseEvent(isClose: boolean): void {
    if (isClose) {
      this.ref.close();
    }
  }

}

export const REGISTER_STEP = {
  RESETPASSWORD: 'resetPasswordStep',
  RESETPASSWORDEMAIL: 'resetPasswordEmailStep',
  REGISTER: 'registerStep',
  LOGIN: 'loginStep',
  LOGINEMAIL: 'loginEmailStep',
  VERIFY: 'verifyStep',
  RESENDCODE: 'resendCodeStep',
  SESSIONEXPIRED: 'sessionExpiredStep',
};
